import React, { FC, useState } from 'react';
import {
  AccordionCardHeader,
  AccordionCardTitle,
  AccordionChevronRight,
  DivCollapse,
  DivCategoryFilter
} from '../../AccordionCardBlock/styles';
import clsx from 'clsx';
import { FilterType, TCheckBoxListValues, TCurrentFilter, TFilter } from '../../../../../commonTypes/filters';
import { CheckboxList } from '../../CheckboxList';
import CheckBoxTreeListTitle from '../../CheckBoxTreeListTitle';

type TProps = {
  data: any;
  currentFilterItems: TCurrentFilter[];
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
};

const CategoryFilter: FC<TProps> = ({ data, currentFilterItems, onSetFilter, onClearFilter }) => {
  const [currentEventKey, setCurrentEventKey] = useState('');

  const handleClick = (e, eventKey) => {
    if (e.target?.classList.contains('filter-card-title') || e.target?.tagName === 'svg') {
      if (eventKey !== currentEventKey) {
        setCurrentEventKey(eventKey);
      } else {
        setCurrentEventKey('');
      }
    }
  };

  return data.defaultValues.map((item: TFilter, index) => {
    return (
      <DivCategoryFilter key={`${item.internalName}-${index}`}>
        <AccordionCardHeader className="filter-card-header">
          <AccordionCardTitle
            onClick={(e) => handleClick(e, item.internalName)}
            className={clsx({ ['is-collapsed']: currentEventKey === item.internalName }, 'filter-card-title')}
          >
            {item.filterTypeName === FilterType.CheckBoxTreeList ? (
              <CheckBoxTreeListTitle
                internalName={item.internalName}
                label={item.displayName}
                defaultValues={item.defaultValues as TCheckBoxListValues}
                currentFilterItems={currentFilterItems}
                onSetFilter={onSetFilter}
                onClearFilter={onClearFilter}
              />
            ) : (
              item.displayName
            )}
            <AccordionChevronRight size={13} />
          </AccordionCardTitle>
        </AccordionCardHeader>
        <DivCollapse className={clsx({ ['show']: currentEventKey === item.internalName })}>
          {item.filterTypeName === FilterType.CheckBoxTreeList && (
            <CheckboxList
              name={item.internalName}
              value={item.defaultValues as TCheckBoxListValues}
              currentFilterItems={currentFilterItems}
              onSetFilter={onSetFilter}
              onClearFilter={onClearFilter}
            />
          )}
        </DivCollapse>
      </DivCategoryFilter>
    );
  });
};

export default CategoryFilter;
